import { render } from "./QuestionIndex.vue?vue&type=template&id=3d0125c8"
import script from "./QuestionIndex.vue?vue&type=script&lang=js"
export * from "./QuestionIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__